import React from 'react';
import ReactDOM from 'react-dom/client';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const primaryColor = '#6600CC';

const customTheme = createTheme({
  palette: {
    primary: {
      main: primaryColor,
      light: '#F3EAFF',
    },
    error: {
      main: '#D14242',
    },
    text: {
      secondary: '#999999',
    }
  },
  typography: {
    fontFamily: '"Open Sans", "Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
  },
  components: {
      MuiTableContainer: {
          styleOverrides: {
              root: {
                boxShadow: 'none',
                backgroundColor: 'white',
                border: '30px solid white',
                borderRadius: 30,
                marginLeft: -30,
                marginRight: -30,
                marginBottom: 20,
              },
          },
      },
      MuiTableRow: {
          styleOverrides: {
              root: {
                  '&:nth-of-type(odd)': {
                      backgroundColor: 'white',
                  },
                  '&:nth-of-type(even)': {
                      backgroundColor: '#EFEFEF',
                  },
              },
          },
      },
      MuiTableCell: {
          styleOverrides: {
              root: {
                  textAlign: 'center',
                  border: 'none',
                  paddingTop: 18,
                  paddingBottom: 18,
              },
              head: {
                  backgroundColor: '#F3E7FF',
                  textTransform: 'uppercase',
                  textAlign: 'center',
                  fontStyle: 'normal',
                  fontWeight: 600,
                  fontSize: '14px',
                  lineHeight: '19px',
              },
          },
      },
      MuiTableSortLabel: {
        styleOverrides: {
          root: {
            '&:hover': {
              color: primaryColor,
            },
            '&.Mui-active': {
              color: primaryColor,
            },
          },
        },
      },
      MuiListItemText: {
          styleOverrides: {
              primary: {
                  fontWeight: 600,
              }
          }
      },
      MuiListItem: {
          styleOverrides: {
              root: {
                  borderRadius: '10px',
                  border: '1px solid transparent',
                  '&.Mui-selected': {
                      color: primaryColor,
                      border: '1px solid',
                  },
              },
          },
      },
      MuiListItemIcon: {
          styleOverrides: {
              root: {
                  color: 'inherit',
                  marginLeft: 8,
                  minWidth: 40,
              }
          }
      },
      MuiBreadcrumbs: {
          styleOverrides: {
              li: {
                  textTransform: 'uppercase',
                  fontSize: '90%',
                  '& .MuiTypography-root': {
                      textTransform: 'uppercase',
                      fontSize: '90%',
                  },
              }
          }
      },
      MuiButton: {
        styleOverrides: {
          outlinedPrimary: {
            padding: '8px 24px',
            borderRadius: '12px',
            textTransform: 'uppercase',
            fontWeight: 600,
            fontSize: '120%',
          },
          containedPrimary: {
            padding: '8px 24px',
            borderRadius: '12px',
            textTransform: 'uppercase',
            fontWeight: 600,
            fontSize: '120%',
          },
          containedError: {
            padding: '8px 24px',
            borderRadius: '12px',
            textTransform: 'uppercase',
            fontWeight: 600,
            fontSize: '120%',
          },
        },
      },
      MuiTypography: {
        variants: [
          {
            props: { variant: 'h5' },
            style: {
              textTransform: 'uppercase',
              fontWeight: 600,
              marginBottom: '10px',
            },
          },
        ],
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            marginTop: '30px',
            borderBottom: 'none !important',
          },
          indicator: {
            display: 'none',
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            textTransform: 'uppercase',
            fontWeight: 600,
            fontSize: '16px',
            marginRight: '16px',
            padding: '20px 50px',
            '&:first-of-type': {
              marginLeft: '32px',
            },
            '&:last-child': {
              marginRight: 0,
            },
            '&.Mui-selected': {
              color: primaryColor,
              backgroundColor: 'white',
              borderTopLeftRadius: '12px',
              borderTopRightRadius: '12px',
              borderTop: 'none',
              borderLeft: 'none',
              borderRight: 'none',
            },
            '&:not(.Mui-selected)': {
              color: '#999999',
              backgroundColor: '#F0F0F0',
              borderTopLeftRadius: '12px',
              borderTopRightRadius: '12px',
            },
          },
        },
      },
  },
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={customTheme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
